import { RegistrationFormData, RegistrationRequestData, ShopInfo, ValidationResult } from 'types/dto/registration';
import ApiClient from 'services/apiClient';

export const fetchRegistrationMediaOptions = async (lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: '/common/getmedia',
    params: { lang: lang },
  });
  return response.data;
};

export const fetchRegistrationShopsOptions = async (
  lang: string
): Promise<ShopInfo[]> => {
  const response = await ApiClient.getInstance().get({
    url: '/common/getshoplist',
    params: { lang: lang },
  });
  return response.data;
};

export const validateRegistration = async (
  module: string,
  phone: string,
  lang: string,
  data: RegistrationFormData
): Promise<ValidationResult> => {
  const requestData = convertToRegistrationRequest(data, phone, lang);
  const response = await ApiClient.getInstance().post({
    url: `${module}/validateregister`,
    data: requestData,
  });
  return response.data;
};

export const saveRegistration = async (
  module: string,
  data: RegistrationRequestData,
  accessToken?: string
): Promise<unknown> => {
  if (accessToken) {
    ApiClient.getInstance().setSessionToken(accessToken);
  }
  const response = await ApiClient.getInstance().post({
    url: `${module}/registersave`,
    data: data,
  });
  return response.data;
};

export const convertToRegistrationRequest = (
  formData: RegistrationFormData,
  phone: string,
  lang: string
): RegistrationRequestData => {
  const requestData: RegistrationRequestData = {
    phone: phone,
    titleCode: formData.titleCode || '',
    firstName: formData.firstName || '',
    lastName: formData.lastName || '',
    email: formData.email || '',
    address: formData.address || '',
    districtCode: formData.districtCode || '',
    district: formData.district || '',
    birthDay: '',
    birthMonth: formData.birthMonth || '',
    birthYear: formData.birthYear || '',
    commPref: (formData.commPref === true || formData.commPref === 'yes') ? 'yes' : 'no',
    qn2: formData.qn2 || 'no',
    packingPlasticBag: formData.packingPlasticBag || 'no',
    agreeTerms: !!formData.agreeTerms,
    howToKnowUs: formData.howToKnowUs || '',
    howToKnowUsOthers: formData.howToKnowUsOthers || '',
    qn3: formData.qn3 || [],
    asiaMile: formData.asiaMile || '',
    sessionID: formData.sessionID || '',
    language: formData.language || 'en',
    setAsPickup: formData.setAsPickup || 'N',
    lang: lang,
    customerID: formData.customerID ?? 0,
    result: formData.result ?? 0,
  };
  return requestData;
};

export const mapBackendErrorToFrontend = (
  backendField: string
): keyof RegistrationFormData | null => {
  const fieldMap: Record<string, keyof RegistrationFormData> = {
    title: 'titleCode',
    titleCode: 'titleCode',
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email',
    asiaMile: 'asiaMile',
    district: 'districtCode',
    districtCode: 'districtCode',
    address: 'address',
    birthMonth: 'birthMonth',
    birthYear: 'birthYear',
    birthDay: 'birthDay',
    qn3: 'qn3',
    favoriteShopType: 'qn3',
    packingPlasticBag: 'packingPlasticBag',
    qn2: 'qn2',
    howToKnowUs: 'howToKnowUs',
    howToKnowUsOthers: 'howToKnowUsOthers',
    commPref: 'commPref',
    agreeTerms: 'agreeTerms',
    setAsPickup: 'setAsPickup',
  };
  return (fieldMap[backendField] as keyof RegistrationFormData) || null;
};

export const createPasswordForVerifiedUser = async (
  tempToken: string,
  password: string,
  new_password: string
): Promise<object> => {
  const response = await ApiClient.getInstance().post({
    url: '/register/create-password',
    data: {
      tempToken,
      password,
      new_password,
    },
  });
  return response.data;
};